// src/pages/Login.jsx
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Auth.css';
import swal from 'sweetalert2';

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false
  });
  const [message, setMessage] = useState('');
  
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  
  const validateForm = () => {
    if (!formData.email) {
      setError('El correo electrónico es obligatorio');
      return false;
    }
    
    if (!formData.password) {
      setError('La contraseña es obligatoria');
      return false;
    }
    
    return true;
  };
  
  // Helper function to generate random string using only native JavaScript
  const generateRandomToken = (length = 32) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return Array.from({ length }, () => 
      characters.charAt(Math.floor(Math.random() * characters.length))
    ).join('');
  };

  const odooURL = 'https://85583adb-06b4-41dd-839f-241c1405c5ae.clouding.host/api/notto/login';

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setIsLoading(true);
    setError('');
    
    try {
      const formDataToSend = new FormData();
      formDataToSend.append('username', formData.email); // Using email as username
      formDataToSend.append('password', formData.password);
      
      console.log('Login data being sent:');
      for (let pair of formDataToSend.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
      }
      
      const response = await fetch(odooURL, {
        method: 'POST',
        body: formDataToSend
      });
      
      const data = await response.json();
      console.log(data);
      
      if (data.status === 'success') {
        // Store auth token
        localStorage.setItem('authToken', data.uid);
        
        // Store user data
        localStorage.setItem('user_info', JSON.stringify(data.user_info));
        localStorage.setItem('providers', JSON.stringify(data.providers));
        localStorage.setItem('bots', JSON.stringify(data.user_info.bots || []));
        localStorage.setItem('connections', JSON.stringify(data.connections || []));
        localStorage.setItem('templates', JSON.stringify(data.flussi || []));
        console.log(data.user_info.bots);
        alert('read');
       // navigate('/dashboard');

        // Generate a random token using our helper function
        const token = generateRandomToken();
        
        const user = data.user_info;
        user.access_token = token;  // Store on the user model
        data.user_info['token'] = token;  // Include in response

        // Store token expiry on the user (7 days from now)
        const expiryDate = new Date();
        expiryDate.setDate(expiryDate.getDate() + 7);
        user.token_expiry = expiryDate;
        
        // Check during validation
        if (user.token_expiry < new Date()) {
          return {'status': 'error', 'message': 'Token expired'};
        }
      } else {
        setError(data.message || 'Error de acceso');
      }
    } catch (error) {
      console.error(error);
      setError('Error de conexión al servidor');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-logo">
            <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="#3182ce" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <path d="M8 14s1.5 2 4 2 4-2 4-2" />
              <line x1="9" y1="9" x2="9.01" y2="9" />
              <line x1="15" y1="9" x2="15.01" y2="9" />
            </svg>
          </div>
          <h1>Notto Bot Manager</h1>
          <p>Inicia sesión en tu cuenta</p>
        </div>
        
        {error && (
          <div className="auth-error">
            {error}
          </div>
        )}
        
        <form onSubmit={handleLogin} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Correo Electrónico</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="correo@ejemplo.com"
              autoComplete="email"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Tu contraseña"
              autoComplete="current-password"
            />
          </div>
          
          <div className="form-row">
            <div className="remember-me">
              <input
                type="checkbox"
                id="rememberMe"
                name="rememberMe"
                checked={formData.rememberMe}
                onChange={handleChange}
              />
              <label htmlFor="rememberMe">Recordarme</label>
            </div>
            
            <Link to="/recover-password" className="forgot-password">
              ¿Olvidaste tu contraseña?
            </Link>
          </div>
          
          <button
            type="submit"
            className="auth-button"
            disabled={isLoading}
          >
            {isLoading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>
        
        <div className="auth-footer">
          <p>¿No tienes una cuenta? <Link to="/register">Regístrate</Link></p>
        </div>
      </div>
    </div>
  );
};

export default Login;